<template>
  <Collapse @open="loadAnswer">
    <template v-slot:title>
      <div class="text-blue-900 font-medium">{{ $lang.app.ANSWERS }}</div>
    </template>
    <template v-slot:content>
      <Loader v-if="loading"/>
      <div v-else class="rounded py-2">
        <div class="w-full pt-2 pl-4 border-solid border-l-4"
             :class="{'border-green-500': isPositiveAnswer(answer), 'border-orange-400': isRemarksAnswer(answer), 'border-red-500': isNegativeAnswer(answer)}">
          <div class="resolution__user resolution__reply__user">
            <div class="resolution__user__left">
              <div class="resolution__user__avatar">
                <img src="@/assets/v2/img/user__avatar.jpg" alt="avatar" class="resolution__user__avatar__img">
              </div>
              <div class="resolution__user__info">
                <div class="resolution__user__name">{{ answer.author?.fullName }}</div>
                <!--                <div class="resolution__user__rule">Куратор</div>-->
              </div>
            </div>
            <div class="resolution__user__right">
              <div class="resolution__user__date">{{ $moment(answer.createdAt).format('DD.MM.YYYY HH:mm') }}</div>
            </div>
          </div>

          <div class="my-3 whitespace-pre-wrap">{{ answer.content }}</div>

          <template v-for="payment in answer.payments" :key="payment.id">
            <div class="border rounded my-2 p-2 text-sm">
              <p v-if="payment.expertPurposeType">
                <span class="text-blue-900 font-medium">{{ $lang.app.PURPOSE_OF_OBJECT }}: </span>
                {{ payment.expertPurposeType.title }}
              </p>
              <p v-if="payment.expertPurposeType">
                <span class="text-blue-900 font-medium">{{ $lang.app.PURPOSE_OF_OBJECT_TYPE }}: </span>
                {{ payment.expertPurposeType.category.title }}
              </p>
              <p v-if="payment.value">
                <span class="text-blue-900 font-medium">{{ $lang.app.VALUE }}: </span>
                {{ payment.value }} {{ payment.unitOfMeasurement ? payment.unitOfMeasurement.shortName : '' }}
              </p>
              <p v-if="payment.total">
                <span class="text-blue-900 font-medium">{{ $lang.app.SUM }}:</span> {{ payment.total }} {{ $lang.app.SOM }}
              </p>
            </div>

            <div class="flex -mx-1.5 flex-wrap">
              <div v-if="payment.paymentFile" class="w-1/3 p-1.5">
                <div class="cursor-pointer border rounded flex p-2 items-center"
                     @click="loadFile(payment.paymentFile)">
                  <PdfIcon class="w-8 h-8 flex-shrink-0"/>
                  <div class="ml-2 text-sm text-gray-600 leading-tight overflow-hidden"
                       :title="payment.paymentFile.filename">{{ payment.paymentFile.filename }}</div>
                </div>
              </div>
              <div v-if="payment.file" class="w-1/3 p-1.5">
                <div class="cursor-pointer border rounded flex p-2 items-center"
                     @click="loadFile(payment.file)">
                  <PdfIcon class="w-8 h-8 flex-shrink-0"/>
                  <div class="ml-2 text-sm text-gray-600 leading-tight overflow-hidden"
                       :title="payment.file.filename">{{ payment.file.filename }}</div>
                </div>
              </div>
            </div>
          </template>

          <div class="resolution__card__files">
            <div v-for="(file, index) in answer.files" :key="index" class="file__grid">
              <a class="cursor-pointer file__item" @click="loadFile(file)">
                <svg viewBox="0 0 24 24" width="24" height="24">
                  <use xlink:href="@/assets/v2/img/sprite.svg#icon__file__pdf"></use>
                </svg>
                <span class="file__item__name">
							{{ file.filename }}
						</span>
              </a>
            </div>
            <div v-if="answer.letterFile" class="file__grid">
              <a class="cursor-pointer file__item" @click="loadFile(answer.letterFile)">
                <svg viewBox="0 0 24 24" width="24" height="24">
                  <use xlink:href="@/assets/v2/img/sprite.svg#icon__file__pdf"></use>
                </svg>
                <span class="file__item__name">
							{{ answer.letterFile.filename }}
						</span>
              </a>
            </div>
          </div>

        </div>
      </div>
    </template>
  </Collapse>
</template>
<script>
import Collapse from "../../../Collapse";
import resolutionApi from "../../../../api/employee/resolution";
import {
  getValueByKey as answerTypesGetValueByKey,
  getLabelRefByValue as answerTypesGetLabelRefByValue
} from "../../../../helpers/constants/answerTypes";
import fileApi from "../../../../api/file";

export default {
  props: {
    resolution: Object
  },
  components: {
    Collapse,
  },
  data() {
    return {
      loading: false,
      answer: null,
    }
  },
  methods: {
    answerTypesGetValueByKey,
    answerTypesGetLabelRefByValue,
    loadAnswer() {
      this.loading = true
      resolutionApi
          .getAnswer(this.$route.params.applicationId, this.resolution.id)
          .then(res => {
            this.answer = res
          }).finally(() => {
            this.loading = false
          })
    },
    isPositiveAnswer(answer) {
      return answer.type === this.answerTypesGetValueByKey('POSITIVE')
    },
    isRemarksAnswer(answer) {
      return answer.type === this.answerTypesGetValueByKey('REMARK')
    },
    isNegativeAnswer(answer) {
      return answer.type === this.answerTypesGetValueByKey('NEGATIVE')
    },
    loadFile(file) {
      this.$emitter.emit('open-loader-modal')
      fileApi.getEmployeeApplicationFile(file.id, this.$route.params.applicationId).then(res => {
        this.$emitter.emit('open-file-modal', res.data)
      }).catch(error => {
        this.$snotify.error(error)
      }).finally(() => {
        this.$emitter.emit('close-loader-modal')
      })
    },
  }
}
</script>